import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import { useGeoState } from '../GeoProvider'
import { useNavigate } from 'react-router-dom'
const DefaultBreadcrumbs = ({
  geo_parent,
  geo_id,
  geo_type,
  dashboardType,
}) => {
  const { setRegionSelected } = useGeoState()
  const history = useNavigate()

  const handleClick = () => {
    setRegionSelected('zip3')
    if (geo_type === 'zip3') {
      history(`/${dashboardType}dashboard#zip3`)
    } else {
      history(`/${dashboardType}dashboard`)
    }
  }

  return (
    <Breadcrumbs>
      {geo_type === 'nat' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/dashboard'}
          />
          <Breadcrumbs.Item className={'label'} key={'US'} label={'US'} last />
        </>
      )}
      {geo_type === 'state' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/dashboard'}
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            href={'/' + dashboardType + 'dashboard'}
          />
          <Breadcrumbs.Item
            className={'label'}
            key={geo_id.toUpperCase()}
            label={geo_id.toUpperCase()}
            last
          />
        </>
      )}
      {(geo_type === 'msa' || geo_type === 'county' || geo_type === 'zip3') && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/dashboard'}
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            // href={'/' + dashboardType + 'Dashboard'}
            onClick={handleClick}
          />
          {geo_type !== 'zip3' && (
            <Breadcrumbs.Item
              key={geo_parent}
              last={geo_type === 'zip3'}
              href={
                '/' + dashboardType + 'statedashboard' + '/state/' + geo_parent.toLowerCase()
              }
              label={geo_parent.toUpperCase()}
            />
          )}

          {geo_type === 'zip3' && geo_id === undefined && (
            <Breadcrumbs.Item
              key={geo_parent}
              last={true}
              href={
                '/' + dashboardType + 'statedashboard' + '/state/' + geo_parent.toLowerCase()
              }
              label={geo_parent.toUpperCase()}
            />
          )}
        </>
      )}
    </Breadcrumbs>
  )
}

export default DefaultBreadcrumbs
